import { publish } from './publish';

export enum NotificationTypeEnum {
  ERROR = 'error',
  SUCCESS = 'success',
}

export enum NotificationContextEnum {
  DEFAULT = 'default',
  BASE = 'base',
  PUBLIC = 'public',
  MODAL = 'modal',
  BLOCK = 'block',
}

export interface NotificationType {
  message: React.ReactNode;
  type?: NotificationTypeEnum;
  context?: NotificationContextEnum;
  persistent?: boolean;
  error?: any;
}

export const MFE_NOTIFICATION_EVENT = 'sxm_mfe_notification';
export const MFE_CLEAR_NOTIFICATIONS_EVENT = 'sxm_mfe_clear_notifications';

export function notify(notification: NotificationType) {
  publish(MFE_NOTIFICATION_EVENT, notification);
}

export function notifySuccess(notification: Omit<NotificationType, 'type'>) {
  publish(MFE_NOTIFICATION_EVENT, {
    ...notification,
    type: NotificationTypeEnum.SUCCESS,
  });
}

export function notifyError(notification: Omit<NotificationType, 'type'>) {
  publish(MFE_NOTIFICATION_EVENT, {
    ...notification,
    type: NotificationTypeEnum.ERROR,
  });
}

export function clearNotifications() {
  publish(MFE_CLEAR_NOTIFICATIONS_EVENT);
}
